// Liveblog

export const layoutValues = ["default", "timeline", "masonry", "horizontal-timeline"] as const
export type LayoutType = typeof layoutValues[number]
export const colorSchemeValues = ['auto', 'light', 'dark'] as const
export type ColorScheme = typeof colorSchemeValues[number]
export const layoutAuthorPositionValues = ["top", "bottomLeft", "bottomRight", "off"] as const
export type LayoutAuthorPosition = typeof layoutAuthorPositionValues[number]
export const layoutEventTagPositionValues = ["top", "bottom", "off"] as const
export type LayoutEventTagPosition = typeof layoutEventTagPositionValues[number]

export const highlightSummaryTypes = ["chapters", "highlights", "highlights-slider", "none"] as const
export type HighlightSummaryType = typeof highlightSummaryTypes[number]

export const eventTagNavigationTypes = ["filter-auto", "filter-list", "filter-search", "none"] as const
export type EventTagNavigationType = typeof eventTagNavigationTypes[number]
export const sortOrderValues = ["asc", "desc"] as const
export type SortOrder = typeof sortOrderValues[number]
export const sortControlsValues = ["off", "show"] as const
export type SortControlsType = typeof sortControlsValues[number]
export const dateTimeDisplayValues = ["smart", "datetime", "date", "time", "none"] as const
export type DateTimeDisplayType = typeof dateTimeDisplayValues[number]

// Liveblog Teaser

export const teaserLayoutValues = ["slider", "slider-autoplay", "list"] as const
export type TeaserLayoutType = typeof teaserLayoutValues[number]
export const teaserSliderLayoutValues: readonly TeaserLayoutType[] = ["slider", "slider-autoplay"]
export function isTeaserSliderLayout(layout: TeaserLayoutType): boolean {
  return teaserSliderLayoutValues.includes(layout)
}

export const teaserTimelineValues = ["off", "on", "time"] as const
export type TeaserTimelineType = typeof teaserTimelineValues[number]

export const teaserContentTypeValues = ["highlights", "highlightsPinned", "newest", "all"] as const
export type TeaserContentType = typeof teaserContentTypeValues[number]

export const teaserLayoutLiveblogLinkValues = ["bottom", "off"] as const
export type TeaserLayoutLiveblogLink = typeof teaserLayoutLiveblogLinkValues[number]

export const teaserLayoutLiveIndicatorStyleValues = ["badge", "indicator", "off"] as const
export type TeaserLayoutLiveIndicatorStyleType = typeof teaserLayoutLiveIndicatorStyleValues[number]

export const teaserLayoutWhenScoreboardValues = ["scoreBoardEvents", "scoreBoard", "events"] as const
export type TeaserLayoutWhenScrorebaordValues = typeof teaserLayoutWhenScoreboardValues[number]
